import {Application} from "../Application";
import {Anchor} from "../core/Anchor";
import {IPoint} from "../core/Geom";
import {Button} from "./Button";

export class MuteButton extends Button {

    constructor() {
        super(undefined, "button-mute-off", Anchor.middleCenter);

        this.visible = false; // TEMP

        this.toggle = true;
        this.selected = Application.instance.audio.masterVolume === 0;
        this.onChange.add(() => {
            Application.instance.audio.masterVolume = this.selected ? 0 : 1;
            // Application.instance.saveManager.storeBool("story-creator-mute", this.selected);
        });
    }

    public setPosition(size: IPoint) {
        this.x = size.x / 2 - this.width * 0.6;
        this.y = -size.y / 2 + this.height * 0.6;
    }
}
